import { Formik } from 'formik';
import React, {useState} from 'react';
import { publicRequest } from '../../api/apiConfig/publicRequest';
import { showErrorNotification } from '../../customHooks';
import FormikControl from '../formikcontrols';
import { Link, Route, useNavigate } from 'react-router-dom';
import './MyProfile.scss';

const MyProfile = () => {
  const [email, setEmail] = useState("");
  const [isOpen, setIsOpen] = useState(true);
  const [isReadonly, setIsReadonly] = useState(true);
  let {data} = JSON.parse(localStorage.getItem('authUser'))
  const navigate = useNavigate()
  
  const initialValues={
    name: data.name,
    email: data.email,
  }

  const closeModal = () => {
    setIsOpen(false)
    navigate('/dashboard')
  }

  const handleChange = (e) => {
    navigate('/dashboard')
    setIsReadonly(false);

    setEmail(e.target.value)
  }

  const handleLoginSubmit = async (e) => {

  }

  return (

    <div className="creat-profile">
      <div style={{ color: "#000", fontSize: "24px", textAlign: "left" }}>My Profile</div>
      <Formik initialValues={data === undefined ? initialValues : { ...data }} onSubmit={handleChange}>
        <form
          className='Profile_name'>
          <FormikControl
            control="input"
            label=" Your Name"
            readOnly={isReadonly}
            name="name"
          />
          <FormikControl
            control="input"
            label=" Your Email"
            readOnly={isReadonly}
            name="email"
          />
          <div className="btn_profile">
            <button className="profile_name_Subtn" type="submit" > {data === undefined?"Save":"Edit"}</button>
        
          <button className="profile_name_Editbtn" onClick={handleChange}>Cancel</button>
        </div>
        
        

       
      </form>
      </Formik>
    </div>
  );
}
export default MyProfile;
